import { useEffect } from "react";
import { Alert, Form, Input, Modal, Typography } from "antd";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";

const { Text } = Typography;

/**
 * Bakanlığa gönderilmiş istemin geri çekilmesi.
 *
 * Teletip'te istem iptali için REST ucu yoktur; iptal, istemin gittiği HL7 kanalından gönderilen
 * bir ORM^O01 mesajıdır (ORC-1 = CA). Mesaj, gönderilmiş istemden birebir türetilir.
 *
 * Gerekçe alanı yalnızca yerel denetim izi içindir — bakanlığın iptal mesajı gerekçe taşımıyor.
 */
export default function EnabizCancelRequestModal({ row, open, onClose, onSuccess }) {
    const [form] = Form.useForm();

    useEffect(() => {
        if (open) form.resetFields();
    }, [open])

    const onFinish = async ({ reason }) => {
        const res = await ApiService.EnabizOperation.CancelRequestHl7(row.id, reason?.trim() || null);
        if (res.success) {
            onSuccess && onSuccess();
            onClose && onClose();
        }
    }

    return (
        <Modal
            title={t('Cancel Request (Teletip)')}
            open={open}
            onCancel={onClose}
            onOk={() => form.submit()}
            okText={t('Send Cancellation')}
            okButtonProps={{ danger: true }}
            cancelText={t('Cancel')}
            destroyOnClose
        >
            {row && (
                <div style={{ marginBottom: 12 }}>
                    <Text type="secondary">{row.patientName} {row.patientLastname} - {row.operationName}</Text>
                    <div><Text type="secondary">Accession: <Text code>{row.accessionNumber || '-'}</Text></Text></div>
                </div>
            )}
            <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 12 }}
                message={t('A cancellation message (ORC=CA) will be sent to the ministry over HL7.')}
                description={t('This withdraws the order. It does not remove the image/KOS record — use Remove KOS for that.')}
            />
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item label={t('Reason (recorded locally only)')} name="reason">
                    <Input.TextArea rows={2} maxLength={1000} showCount />
                </Form.Item>
            </Form>
        </Modal>
    )
}
